import { api } from '~/plugins/api'
import { LeituraRepository } from './leitura-repository'

export * from './tipo-leitura'
export * from './leitura'
export * from './leitura-repository'

export const leitura_repository = new LeituraRepository(api)